import { PricingPlan } from "./pricing-plan.types";

interface PricingCardProps {
  scrollToSection: (sectionId: string, text?: string) => void;
  plan: PricingPlan;
  index: number;
}

const PricingCard: React.FC<PricingCardProps> = ({ scrollToSection, plan }) => {
  const sendToContact = (text: string) => {
    scrollToSection('contato', text);
  }
  return (
    // <div className={`relative p-8 rounded-2xl text-center transition-all duration-300 ${
    //   plan.featured 
    //     ? 'bg-gradient-to-br from-indigo-600 to-purple-600 text-white transform scale-105 shadow-2xl' 
    //     : 'bg-white border-2 border-gray-200 hover:border-indigo-500 hover:transform hover:-translate-y-2 hover:shadow-xl'
    // }`}>
    <div className={`relative p-8 rounded-2xl text-center transition-all duration-300 ${plan.featured
      ? 'bg-gradient-to-br from-orange-500 to-orange-600 text-white transform scale-105 shadow-2xl'
      : 'bg-white border-2 border-gray-200 hover:border-orange-500 hover:transform hover:-translate-y-2 hover:shadow-xl'
      }`}>
      {plan.badge && (
        <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-yellow-500 text-white px-4 py-1 rounded-full text-sm font-semibold">
          {plan.badge}
        </div>
      )}

      <h3 className="text-2xl font-semibold mb-2">{plan.name}</h3>
      <div className="text-5xl font-bold mb-2">{plan.price}</div>
      <div className={`mb-8 ${plan.featured ? 'text-white/80' : 'text-gray-600'}`}>{plan.period}</div>
      {plan.total ? <div className={`mb-8 ${plan.featured ? 'text-white/80' : 'text-gray-600'}`}>{plan.total}</div> : <div></div>}


      <ul className="space-y-4 mb-8 text-left">
        {plan.features.map((feature, idx) => (
          <li key={idx} className="flex items-center">
            <span className={`mr-3 ${plan.featured ? 'text-white' : 'text-green-500'}`}>✓</span>
            {feature}
          </li>
        ))}
      </ul>

      <button
        onClick={() => sendToContact(plan.contactText)}
        className={`w-full py-3 px-6 rounded-xl font-semibold transition-all duration-300 ${plan.featured
          ? 'bg-white/20 border-2 border-white/30 text-white hover:bg-white/30'
          : 'bg-orange-500 text-white hover:bg-orange-700'
          }`}>
        {plan.buttonText}
      </button>
    </div>
  );
}

export default PricingCard;